import {Injectable} from '@angular/core';
import * as L from 'leaflet';
import {geoJSON, marker} from 'leaflet';
import {MimeTypeService} from './mime-type.service';
import {GeopointHelper} from './utils/geopoint-helper';
import {mapPane} from './models/map-pane.models';

@Injectable({
  providedIn: 'root'
})
export class GeopointFactoryService {
  constructor(
    protected mimeTypeService: MimeTypeService
  ) {
  }

  createGeopointLayer(geopoint: any) {
    const layers = geoJSON(
      JSON.parse(geopoint.geometry),
      {
        pointToLayer: (geoJsonPoint, latlng) => {
          const icon = GeopointHelper.createIconForGeopointType(geopoint['geopoint-type'], this.mimeTypeService);

          const options: L.MarkerOptions = {
            draggable: false,
            icon: icon,
            title: geopoint.name,
            // @ts-ignore
            pmIgnore: true,
            pane: mapPane.GEOPOINT
          };
          return marker(latlng, options);
        }
      }
    );

    layers.bindTooltip(
      geopoint.name,
      {
        direction: 'bottom',
        permanent: false,
        offset: [0, 13]
      }
    );
    if (geopoint.description && geopoint.description.length > 0) {
      layers.bindPopup(geopoint.description, {offset: [0, -3]});
    }
    geopoint.layer = layers;
    return geopoint;
  }
}
